:host {
    display: block;
  }
  
  .modal {
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  
  .modal-content {
    background-color: #ffffff;
    margin: 5% auto;
    padding: 20px;
    border-radius: 12px;
    width: 90%;
    max-width: 600px;
  }
  
  .modal-header {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .close {
    float: right;
    cursor: pointer;
    padding: 5px;
  }
